<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelCheck()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button *ngIf="documentTemp.customer.id && documentTemp.site.id" (click)="scanItem()">
                <ion-icon slot="icon-only" name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Buffer Stock Reconciliation</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <customer [document]="documentTemp" (customerChange)="listenCustomer($event)"></customer>
    <site [document]="documentTemp" (siteChange)="listenSite($event)"></site>
    <!--    <ion-button color="light" expand="full" shape="round" *ngIf="documentTemp.customer.id && documentTemp.site.id"-->
    <!--                (click)="scanItem()">-->
    <!--        Scan-->
    <!--        <ion-icon slot="end" name="barcode"></ion-icon>-->
    <!--    </ion-button>-->

    <ion-item *ngIf="documentTemp.site && documentTemp.site.id">
        <ion-input [(ngModel)]="manualInput" placeholder="Manual barcode input"></ion-input>
        <ion-button slot="end" (click)="handleScanResult(manualInput)" [disabled]="!manualInput" color="light">
            <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
    </ion-item>

    <ion-item *ngIf="documentTemp.site && documentTemp.site.id && this.documentTemp.detailLines && this.documentTemp.detailLines.length">
        <ion-label>This ward has {{this.documentTemp.detailLines.length}} Items</ion-label>
    </ion-item>

    <ion-list
            *ngIf="documentTemp.site && documentTemp.site.id && this.documentTemp.detailLines && this.documentTemp.detailLines.length">
        <ion-item *ngFor="let line of this.documentTemp.detailLines">
            <ion-label>
                <p>{{line.description}}</p>
                <p>{{line.pdesc}}/{{line.reg}}</p>
            </ion-label>
            <ion-icon *ngIf="line.isChecked" name="check" color="success" slot="end"></ion-icon>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="saveSaveReconciliation()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>
